class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.trendingAndProductsBlock = this.querySelector('[data-quick-trending-products]');
    this.closeStickySearchButton = document.querySelector('.header-search-close');
    this.productToShow = this.dataset.productToShow;
    this.searchDetails = this.querySelector('.search_details');
    this.predictiveSearch = this.querySelector('predictive-search')
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
    this.mipRequestVersion = 0;
    this.mipSearchIntent = false;
    this.mipSurfaceListeners = new AbortController();
    this.quickSearchTrending = this.querySelectorAll('.quickSearchTrending .link');
    this.searchResultsWidget = this.getElementsByClassName('quickSearchResultsWidget')[0];

    this.setupEventListeners();
    this.quickSearchTrending.forEach(element => {
      element.addEventListener('click', this.quickSearchTrendingClick.bind(this));
    });
  }
  
  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));

    this.setupSurfaceListeners();
  }

  setupSurfaceListeners() {
    document.addEventListener('click', this.onDocClick.bind(this), { signal: this.mipSurfaceListeners.signal });
    document.addEventListener('mip:surface:open', (event) => {
      if (!event.detail || event.detail.owner === this) return;
      if (this.mipSearchIntent || this.hasAttribute('data-mip-search-active')) {
        this.close();
        this.onCloseStickySearchClick();
        if (this.contains(document.activeElement)) document.activeElement.blur();
      }
    }, { signal: this.mipSurfaceListeners.signal });
    const reposition = () => {
      if (!this.hasAttribute('data-mip-search-active') || this.mipBoundFrame) return;
      this.mipBoundFrame = requestAnimationFrame(() => { this.mipBoundFrame = null; this.boundPanels(); });
    };
    window.addEventListener('resize', reposition, { passive: true, signal: this.mipSurfaceListeners.signal });
    window.addEventListener('scroll', reposition, { passive: true, signal: this.mipSurfaceListeners.signal });
    window.addEventListener('pagehide', () => this.close(), { signal: this.mipSurfaceListeners.signal });
    if (this.closeStickySearchButton != null) {
      this.closeStickySearchButton.addEventListener('click', this.onCloseStickySearchClick.bind(this), { signal: this.mipSurfaceListeners.signal });
    }
  }

  handleResponse(data,limit) {
    let htmlMedia = document.createElement('div');
    htmlMedia.innerHTML = data;

    $(htmlMedia).find(`.product:nth-child(n+${Number(limit) + 1})`).remove();
    return $(htmlMedia).html();
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    // A delayed input callback must not reopen search after the shopper chose a menu.
    if (!this.isConnected || (!this.mipSearchIntent && !this.contains(document.activeElement))) return;
    this.mipSearchIntent = true;
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      const keepTrendingOpen = this.contains(document.activeElement);
      this.close(true);
      if (keepTrendingOpen) this.showTrendingAndProducts();
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.close(true);
    }
  }

  onFocus() {
    if (this.mipSuppressFocus) return;
    this.mipSearchIntent = true;
    this.claimSurface();
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return this.showTrendingAndProducts();

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }
  
  onKeyup(event) {
    if (event.key === 'Escape' || !this.mipSearchIntent) return;
    if (!this.getQuery().length) {
      this.close(true);
      this.showTrendingAndProducts();
    };
    event.preventDefault();
    
    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault(); event.stopPropagation();
      this.onCloseStickySearchClick();
      this.mipSuppressFocus = true;
      this.input.focus({ preventScroll: true });
      this.mipSuppressFocus = false;
      return;
    }
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
  
    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    if (this.statusElement) this.statusElement.textContent = '';
    if (!allVisibleElements.length) return;
    
    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }
    
  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }
  
  getSearchResults(searchTerm) {
    if (!this.mipSearchIntent || !this.isConnected) return;
    const queryKey = searchTerm.toLowerCase();
    this.abortController.abort();
    this.abortController = new AbortController();
    const version = ++this.mipRequestVersion;
    const current = () => this.isConnected && this.mipSearchIntent && version === this.mipRequestVersion;
    this.setLiveRegionLoadingState();
    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      this.updateViewAllLink(searchTerm);
      return;
    }
    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=query,product,collection,page,article`, {
      signal: this.abortController.signal,
    }).then(response => {
      if (!response.ok) throw new Error('Search request failed: ' + response.status);
      return response.text();
    }).then(text => {
      if (!current()) return;
      const section = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
      if (!section) throw new Error('Search section missing');
      const resultsMarkup = section.innerHTML;
      document.querySelectorAll('predictive-search').forEach(instance => {
        if (!instance.cachedResults) return;
        instance.cachedResults[queryKey] = resultsMarkup;
        const keys = Object.keys(instance.cachedResults);
        if (keys.length > 20) delete instance.cachedResults[keys[0]];
      });
      this.renderSearchResults(resultsMarkup);
      this.updateViewAllLink(searchTerm);
    }).catch(error => {
      if (error.name === 'AbortError' || !current()) return;
      this.removeAttribute('loading');
      this.setLiveRegionText('Suggestions could not be loaded. Press Enter to search.');
      // The normal search form still works; no unhandled promise or hidden navigation.
    });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
    
    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    if (!this.statusElement) return;
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;
    
    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    if (!this.mipSearchIntent || !this.isConnected) return;
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);
    this.setAttribute('open', true);
    this.setLiveRegionResults();
    this.open();
    this.hideTrendingAndProducts();
    if($('.dropdown-item[data-currency]').length){
      if ((window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
        Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
      }
    }
    window.sharedFunctions?.swapHoverVideoProductCard();
    if($('body').hasClass('product-card-layout-08')) {
      window.sharedFunctions?.productCountdownCard();
    }
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    const count = this.querySelector('[data-predictive-search-live-region-count-value]');
    if (count) this.setLiveRegionText(count.textContent);
  }
  
  getResultsMaxHeight() {
    const panel = this.predictiveSearchResults;
    const top = panel ? panel.getBoundingClientRect().top : this.input.getBoundingClientRect().bottom;
    this.resultsMaxHeight = Math.max(80, window.innerHeight - Math.max(0, top) - 16);
    return this.resultsMaxHeight;
  }

  claimSurface() {
    if (!this.isConnected) return;
    if (!this.hasAttribute('data-mip-search-active')) {
      document.dispatchEvent(new CustomEvent('mip:surface:open', { detail: { surface: 'search', owner: this } }));
    }
    this.setAttribute('data-mip-search-active', '');
    const layer = this.closest('.section-header-utility, .section-header-navigation, .section-header-mobile, .shopify-section');
    if (layer) { this.mipLayer = layer; layer.classList.add('mip-search-layer'); }
    document.documentElement.classList.add('mip-search-open');
  }

  releaseSurface() {
    this.removeAttribute('data-mip-search-active');
    if (this.mipLayer && !this.mipLayer.querySelector('predictive-search[data-mip-search-active]')) this.mipLayer.classList.remove('mip-search-layer');
    if (!document.querySelector('predictive-search[data-mip-search-active]')) document.documentElement.classList.remove('mip-search-open');
  }

  boundPanels() {
    if (!this.hasAttribute('data-mip-search-active') || !this.isConnected) return;
    [this.predictiveSearchResults, this.trendingAndProductsBlock].filter(Boolean).forEach(panel => {
      if (!panel.getClientRects().length) return;
      panel.style.setProperty('--mip-search-shift', '0px');
      const r = panel.getBoundingClientRect();
      const shift = r.right > window.innerWidth - 16 ? window.innerWidth - 16 - r.right : r.left < 16 ? 16 - r.left : 0;
      panel.style.setProperty('--mip-search-shift', shift + 'px');
      panel.style.setProperty('--mip-search-max-height', Math.max(80, window.innerHeight - Math.max(0, r.top) - 16) + 'px');
    });
  }

  open() {
    if (!this.mipSearchIntent || !this.isConnected) return;
    this.claimSurface();
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
    this.boundPanels();
  }

  connectedCallback() {
    // Some header/editor paths move the existing element rather than construct a new one.
    if (this.mipSurfaceListeners && this.mipSurfaceListeners.signal.aborted) {
      this.mipSurfaceListeners = new AbortController();
      this.setupSurfaceListeners();
    }
  }

  disconnectedCallback() {
    this.close();
    this.mipSurfaceListeners.abort();
    cancelAnimationFrame(this.mipBoundFrame);
    this.mipBoundFrame = null;
  }

  close(clearSearchTerm = false) {
    this.mipSearchIntent = false;
    this.mipRequestVersion += 1;
    this.abortController.abort();
    this.closeResults(clearSearchTerm);
    this.hideTrendingAndProducts();
    this.isOpen = false;
    this.releaseSurface();
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }

  showTrendingAndProducts() {
    if (!this.trendingAndProductsBlock) return 
    this.trendingAndProductsBlock.classList.add('is-show')
    this.trendingAndProductsBlock.classList.remove('hidden');
    this.mipSearchIntent = true;
    this.claimSurface();
    this.input.setAttribute('aria-expanded', 'true');
    this.isOpen = true;
    this.boundPanels();
  }

  hideTrendingAndProducts() {
    if (!this.trendingAndProductsBlock) return 

    this.trendingAndProductsBlock.classList.remove('is-show')
    this.trendingAndProductsBlock.classList.add('hidden');
  }

  onDocClick(e) {
    const isInModal = this.contains(e.target), $target = e.target

    if (!isInModal || $target.closest('.header-search-popup-close') || $target.matches('.header-search-popup-close') || $target.closest('.header-search-close') || $target.matches('.header-search-close')) {
      this.close();
      this.hideTrendingAndProducts();
    }
  }

  onCloseStickySearchClick() {
    this.close();
    this.hideTrendingAndProducts();
    document.querySelector('body').classList.remove('sticky-search-open');
    document.querySelector('body').classList.remove('sticky-search-menu-open');
    this.closest('[class*="section-header-"]')?.classList.remove('sticky-search-menu-open')
    this.closest('[class*="section-header-"]')?.classList.remove('sticky-search-menu-custom-open')
  }

  updateViewAllLink(searchTerm) {
    const qsViewAllLink = this.querySelector('[data-qs-view-all-link]');
    const version = this.mipRequestVersion;
    if (!qsViewAllLink) return 
    // const linkTotal = `${routes.search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product`
    const linkTotal = `${routes.search_url}?q=${encodeURIComponent(searchTerm)}&options%5Bprefix%5D=last&type=product`;
    
    qsViewAllLink.href = linkTotal
    return this.getTotalResults(linkTotal).then(count => {
      if (count != null && version === this.mipRequestVersion && this.mipSearchIntent && qsViewAllLink.isConnected) qsViewAllLink.innerHTML = qsViewAllLink.innerHTML.replace('()', `(${count})`)
    });
  }

  getTotalResults(url) {
    return fetch(url, { signal: this.abortController.signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }

        return response.text();
      })  
      .then((text) => {
        const totalCount = new DOMParser().parseFromString(text, 'text/html').querySelector('[id^="SearchSection"]')?.dataset.searchCount;
        return totalCount
      })
      .catch(() => null); // Optional total-count request cannot close or reopen search.
  }

  quickSearchTrendingClick(event) {
    window.location = event.currentTarget.getAttribute('href');
  }
}

customElements.define('predictive-search', PredictiveSearch);
